import { Button, ButtonGroup, Flex, ScrollView } from "@aws-amplify/ui-react"
import type { MachineSupaDto } from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { listMachines } from "../../api/MachinesApi"
import { LoadingErrorState, RoundedCard } from "../../components"
import MachineTable from "../../components/admin/MachineTable"
import SearchField from "../../components/maschinen-liste/SearchField"

export function AdminMachines() {
  const [machines, setMachines] = useState<MachineSupaDto[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    const loadMachines = async () => {
      setLoading(true)
      setMachines(null)
      setError(undefined)
      try {
        const _machines = await listMachines()
        setMachines(_machines || null)
      } catch (err) {
        console.log(
          "AM.loadMachines: Caught an error:",
          JSON.stringify(err, null, 2)
        )
        setError(getErrorMessage(err))
      } finally {
        setLoading(false)
      }
    }
    loadMachines()
  }, [])

  if (loading || error) {
    /** @todo add white text color */
    return (
      <LoadingErrorState
        isLoading={loading}
        loadingMessage={I18n.get("Lade Maschinen, bitte warten...")}
        isError={!!error}
        errorMessage={`${I18n.get("Fehler")}: ${I18n.get(error!)}`}
      />
    )
  }

  const loadedMachines = machines!

  // function redirectToCreateMachine() {
  //   navigate("./new/")
  // }

  return (
    <main className="p-8 pt-2">
      <Flex
        className="!mb-4"
        justifyContent="space-between"
        alignItems="center"
        alignContent="center"
      >
        <div className="page-heading">{I18n.get("Maschinen verwalten")}</div>
        <SearchField whiteBackground={true} />
      </Flex>

      <RoundedCard>
        <ScrollView
          width="100%"
          height="calc(100vh - 300px)" // or any desired height
          minHeight="200px"
        >
          <MachineTable machines={loadedMachines} />
        </ScrollView>

        <ButtonGroup size="small">
          {/* <Button onClick={redirectToCreateMachine}>
            {I18n.get("Maschine hinzufügen")}
          </Button> */}

          <Link to="..">
            <Button variation="link" size="small">
              {I18n.get("Zurück")}
            </Button>
          </Link>
        </ButtonGroup>
      </RoundedCard>
    </main>
  )
}
